import { ChangeDetectionStrategy, Component, computed, inject, input, linkedSignal } from '@angular/core';
import { apply, disabled, form, FormField, FormRoot } from '@angular/forms/signals';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { RouterLink } from '@angular/router';
import { COUNTRIES } from '../../../../shared-lazy/components/join-form/countries';
import { DotsLoaderComponent } from '../../../../shared/components/dots-loader/dots-loader.component';
import { ClickCursorDirective } from '../../../../shared/directives/click-cursor.directive';
import { AUTH_USER_ROLES, UserDetails } from '../../../auth0/models';
import { Auth0Store } from '../../../auth0/store';
import {
  hasProfileError,
  isOtherCountry,
  profileCountry,
  profileFormModel,
  profileFormSchema,
} from '../../../auth0/utils/profile-form';
import { UserUtils } from '../../../auth0/utils/user.utils';

@Component({
  selector: 'gnx-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss'],
  imports: [FormField, FormRoot, MatSelect, MatOption, RouterLink, ClickCursorDirective, DotsLoaderComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProfileDetailsComponent {
  protected auth0Store = inject(Auth0Store);
  ROLES = AUTH_USER_ROLES;
  COUNTRIES = COUNTRIES;
  protected readonly hasError = hasProfileError;

  readonly data = input<UserDetails>(undefined);

  protected showUserRole = computed(
    () => this.data().org_config?.userConfig?.rolesAndPermissionsConfig?.active ?? false,
  );
  private serverProfile = computed(() => {
    const data = this.data();
    return {
      ...profileFormModel(data),
      organizationalRole: UserUtils.isUserAnAdmin(data) ? 'Admin' : 'Member',
      userRole: data.applicative_role ? data.applicative_role[0].toUpperCase() + data.applicative_role.slice(1) : '',
    };
  });
  private profile = linkedSignal(() => this.serverProfile());
  protected profileForm = form(this.profile, (path) => {
    apply(path, profileFormSchema);
    disabled(path.organizationalRole);
    disabled(path.userRole);
  });
  protected isOtherCountry = computed(() => isOtherCountry(this.profile()));

  onCancel() {
    this.profileForm().reset(this.serverProfile());
  }

  onSubmit() {
    const profile = this.profile();
    this.auth0Store.updateUserInfo({
      firstName: profile.firstName,
      lastName: profile.lastName,
      role: profile.role,
      country: profileCountry(profile),
    });
  }
}
